import { useCallback } from 'react';
import { generatePath, useHistory } from 'react-router-dom';

import { sanitizeUrl } from '@provider-portal/common/utils/sanitizeUrl';
import { History } from 'history';

import { consoleLog } from '../../utils/consoleLog';

type AbstractRoute<TParams> = string | { index: string; useParams?: () => TParams };
type AbstractRouteParams = Parameters<typeof generatePath>[1];

export function performNavigate<TParams extends AbstractRouteParams>(
  history: History<TParams>,
  route: AbstractRoute<TParams>,
  params?: TParams,
) {
  const url = typeof route === 'string' ? sanitizeUrl(route) : route.index;
  consoleLog(`[NAVIGATE]`, params ? generatePath(url, params) : url);
  history.push({ pathname: params ? generatePath(url, params) : url });
}

export function usePerformNavigate(route: string | { index: string }) {
  const history = useHistory<AbstractRouteParams>();

  return useCallback(() => {
    performNavigate(history, route);
  }, [history, route]);
}
